const data = {
  respuesta: [
    {
      FileName: 'GLE_F2022008902 1_OK.xml',
      esquema: 'ZCPGE',
      schemaValidationErrors: [
        // {
        //   errorPath: '/Facturas/Factura/Cliente/Nombre',
        //   validationMessage: "El elemento 'Cliente' tiene un elemento secundario 'Nombre' no válido. Lista esperada de elementos posibles: 'Cif'."
        // },
        // {
        //   errorPath: '/Facturas/Factura/LineasImpuestos/LineaImpuesto/Impuesto/RecEq',
        //   validationMessage: "El elemento 'Impuesto' tiene un elemento secundario 'RecEq' no válido. Lista esperada de elementos posibles: 'Tipo'."
        // }
      ]
    }
  ],
  blnError: false,
  codError: null,
  msgError: null
}

export default data
